var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumanLogo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 57.9 60",
    style: {
      enableBackground: "new 0 0 57.9 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#7C41D8;}\n\t.st1{fill:#F4DC67;}\n\t.st2{fill:#84561A;}\n\t.st3{fill:none;stroke:#000000;stroke-width:0.66;stroke-miterlimit:10;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:#2F7537;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "corps_et_ailes_maitre"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.1,53.8c5.2,0.2,10.3,0.5,15.4-0.5c1.3-0.2,2.7-0.7,3.3-1.9c0.3-0.7,0.4-1.5,0.3-2.3 c-0.1-1.3-0.4-2.6-0.8-3.8c-0.5-1.1-1-1.2-2.2-1s-1.9,0.5-2.8,0.8c-1.1,0.3-2.3,0.5-3.5,0.5c-1.3,0.3-2.6,0.3-3.8,0.3 c-1.2-0.2-2.4-0.4-3.6-0.8c-1.3-0.1-2.4-0.5-3.4-1c-1.1-0.6-1.7-1.7-2.7-2.4c-1.6-1-2.2-0.1-2.4,1.5c-0.2,2-0.2,3.9,0.2,5.9 c0.2,1,0.9,1.7,0.6,2.7c-0.2,0.6-1.5,1.1-0.6,1.8c0.3,0.2,0.6,0.3,0.9,0.2C17.7,53.7,19.4,53.7,21.1,53.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tete_maitre"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.4,17.1c-6.2,0.3-11.5,6.4-10.8,12.6c0,0.4,0.1,1-0.3,1.2c-0.3,0.1-0.6,0.2-0.9,0.2 c-1.4,0.3-1.8,2.2-1,3.4c0.9,1.1,2.2,1.7,3.6,1.9c1.3,3.3,3.1,6.7,6.2,8.5c2.4,1.2,5.1,1.7,7.8,1.5c3.4,0.1,6.7-0.7,9.7-2.3 c2.9-1.7,5.2-4.8,5.2-8.1c1.4,0.8,3.1,0.3,3.9-1c0.8-1.4,0.4-3.1-1-3.9c-0.4-0.2-0.8-0.3-1.2-0.4c0.2-4.6-2.1-8.9-5.9-11.5 c-3.8-2.4-8.3-3.4-12.8-2.8c-2.5,0.3-4.9,1-7.3,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.2,20c-0.1,2.5-0.6,5-1.5,7.3c-1,2.4-3,4.1-5.5,4.6C14,32.1,12.8,31.8,12,31c-0.8-1-1.2-2.3-1-3.6 c0.1-3.5,1-7.1,3.3-9.7s6.3-3.9,9.4-2.5c0.2-1.3,1.6-2,2.8-2.3c5.5-1.5,11.4-0.3,16,3.1c1,0.7,1.8,1.6,2.5,2.6 c0.7,1.1,1.1,2.4,1.3,3.6c0.4,2.4,0.4,4.8-0.2,7.1c-0.1,0.3-0.2,0.6-0.4,0.9c-0.3,0.3-0.6,0.5-1,0.6c-4.6,1.5-9.7-0.1-14.1-1.9 c-2.1-0.7-4-1.8-5.7-3.2c-1.7-1.4-2.8-3.5-2.9-5.7c0.5,1.7,0.2,3.5-0.8,5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M25,38.7c0.4,0.6,0.9,1.2,1.5,1.6c0.6,0.5,1.3,0.7,2.1,0.6c1.2-0.2,2-1.4,2.6-2.5h-0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M31.6,32.6c0.9-0.6,2.1-0.9,3.2-0.8c0.6,0.1,1.1,0.2,1.7,0.3c0.5,0.2,2.1,0.8,2.1,0.8 c-0.5,0.6-1.2,1.2-1.8,1.6c-0.9,0.5-1.7,1.3-3,1.1c-1.2-0.4-2.4-1.1-3.5-1.9L31.6,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M35.3,32.8c-0.2-0.3-0.6-0.6-0.9-0.7C34.2,32,33.9,32,33.7,32s-0.4,0.1-0.6,0.2c-0.3,0.2-0.5,0.5-0.6,0.9 c-0.2,0.9,0.2,1.8,1,2.2c0.1,0.1,0.3,0.1,0.4,0.1c0.9,0,1.7-0.8,1.8-1.7C35.6,33.4,35.5,33.1,35.3,32.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M24.3,31.9l-0.6-0.2c-2.3-1-4.5,0-6.4,1.3c0.6,0.3,1.1,0.7,1.6,1.1c0.4,0.4,0.9,0.6,1.4,0.8 c1.4,0.3,2.9,0.1,4.2-0.5c0.8-0.5,1.5-1.1,2.1-1.9C25.9,32.3,25.1,32.1,24.3,31.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M22.8,34c0.4-0.8,0.2-1.7-0.5-2.2c-0.4-0.3-0.9-0.4-1.5-0.4c-1.1,0.3-1.1,1.5-0.8,2.4 c0.1,0.2,0.1,0.4,0.3,0.5c0.2,0.1,0.4,0.2,0.6,0.3c0.4,0.1,0.8,0.1,1.2-0.1C22.5,34.4,22.7,34.2,22.8,34z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bras"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.6,56.2c1.9-0.6,3.9-1.1,5.9-1.5c0.9-0.2,3.8-0.6,4.2-1.3c0.1-0.1,0.1-0.3,0-0.5c-0.1-1.1-0.8-2-1.8-2.5 c-1.3-0.3-2.7-0.3-4,0c-3.5,0.4-7,0.3-10.4-0.1C20,50,16.6,49.9,13.1,50c-2.4,0-4.8,0.2-7.2,0.4c-0.9,0-1.8,0.2-2.6,0.6 c-0.4,0.3-0.8,0.6-1.1,1c-0.8,1-1.6,2.1-2.2,3.2c0.1,0.1,0,0.3,0,0.4c0,0.2,0.1,0.3,0.2,0.4c0.5,0.8,1,1.5,1.5,2.3 c0.3,0.5,0.6,0.9,1.1,1.2c0.4,0.2,0.8,0.3,1.3,0.3C5.4,59.9,6.6,60,7.9,60c2.1,0,4.1-0.5,6.1-0.7s3.9-0.5,5.9-0.8 c1.9-0.2,3.9-0.5,5.8-0.9C27,57.2,28.3,56.6,29.6,56.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M54.4,51.6c0.3,0.2,0.6,0.5,0.9,0.7l2,1.7c0.3,0.2,0.5,0.5,0.6,0.8c0.1,0.5,0,1-0.4,1.4 c-0.5,0.6-1,1.1-1.7,1.5c-0.8,0.7-1.7,1.2-2.7,1.6c-1.9,0.6-4-0.2-6-0.2c-1.4,0-2.9-0.1-4.3-0.2c-3.5-0.1-7.1-0.5-10.6-0.6 c-1.1,0-2.2-0.1-3.3-0.2c-1.2-0.1-2.4-0.1-3.6,0.1L18,58.5c3-1.5,6.1-2.7,9.4-3.5s6.6-0.8,9.9-1.5c2.5-0.5,4.9-1,7.4-1.4 c2.4-0.5,4.8-0.8,7.3-1c0.7-0.1,1.4,0,2,0.2C54.1,51.5,54.2,51.5,54.4,51.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanLogo3);
export default __webpack_public_path__ + "static/media/human_logo_3.ad22cd7887fe7c639c528f7c0b8ee26d.svg";
export { ForwardRef as ReactComponent };